/* @flow */
import * as React from 'react';
import idx from 'idx';

import Button from 'components/Button';
import TitleHeader from 'components/TitleHeader';
import AdminNoticeBanner from 'admin/components/AdminNoticeBanner';
import Link from 'components/Link';
import Text from 'components/Text';

import type { AdminDistrictSisDashboard_organizations } from 'admin/queries/__generated__/AdminDistrictSisDashboard';

type Props = {
  title: string,
  subtitle: string,
  organization: AdminDistrictSisDashboard_organizations,
};

function renderMatchingBanner(orgUuid: string) {
  const button = (
    <Button
      eventElementName="AdminDistrictSisDashboardCleverHeader-matchYourSchools"
      href={`/sync_setup/matching?district_uuid=${orgUuid}`}>
      Match your schools
    </Button>
  );
  return (
    <AdminNoticeBanner glyph="success-checkmark-stroke" color="brand" actionElement={button}>
      <Text element="div">Finish setup by mapping your schools from Clever correctly.</Text>
    </AdminNoticeBanner>
  );
}

function renderSetupBanner(orgUuid: string) {
  return (
    <AdminNoticeBanner glyph="success-checkmark-stroke" color="brand" actionElement={null}>
      <Text element="div">
        Get started by logging into Clever. View details in the upper right or{' '}
        <Link href={`/sync_setup?district_uuid=${orgUuid}`} weight="semibold">
          click here
        </Link>
        .
      </Text>
    </AdminNoticeBanner>
  );
}

export default function AdminDistrictSisDashboardCleverHeader(props: Props) {
  const { title, subtitle, organization } = props;
  const { childOrganizations, uuid: orgUuid } = organization;

  const noCleverSchoolsSetUp = childOrganizations.every(
    org => idx(org, _ => _.sisSyncOverview.syncStatus) === 'not_set_up'
  );
  const someCleverSchoolsNotSetUp = childOrganizations.some(
    org => idx(org, _ => _.sisSyncOverview.syncStatus) === 'not_set_up'
  );

  const showSetupBanner = noCleverSchoolsSetUp;
  const showMatchingBanner = !showSetupBanner && someCleverSchoolsNotSetUp;

  return (
    <TitleHeader
      title={title}
      subtext={subtitle}
      action={
        <Button level="secondary" href={`/sync_setup?district_uuid=${orgUuid}`}>
          Set up Clever sync
        </Button>
      }
      actionPlacement="right"
      className="AdminDistrictSisDashboardCleverHeader">
      {showSetupBanner && renderSetupBanner(orgUuid)}
      {showMatchingBanner && renderMatchingBanner(orgUuid)}
    </TitleHeader>
  );
}
